import { render, staticRenderFns } from "./DesignComponentsThumbnail.vue?vue&type=template&id=02ca0914&scoped=true"
import script from "./DesignComponentsThumbnail.vue?vue&type=script&lang=js"
export * from "./DesignComponentsThumbnail.vue?vue&type=script&lang=js"
import style0 from "./DesignComponentsThumbnail.vue?vue&type=style&index=0&id=02ca0914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ca0914",
  null
  
)

/* custom blocks */
import block0 from "./DesignComponentsThumbnail.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports